import type { MonitorEventKind } from '@/hooks/integrations/monitor-request';
import type {
  GenericEventCron,
  GenericEventPigello,
  GenericEventWebhook,
} from '../types';
import type { IntegrationGroup } from '../groups';

export const INTEGRATION_STATUS = {
  ACTIVE: 0,
  ACTION_REQUIRED: 1,
  INACTIVE: 2,
} as const;

export type IntegrationStatus =
  (typeof INTEGRATION_STATUS)[keyof typeof INTEGRATION_STATUS];

export const INTEGRATION_STATUS_LABELS: Record<IntegrationStatus, string> = {
  [INTEGRATION_STATUS.ACTIVE]: 'Aktiv',
  [INTEGRATION_STATUS.ACTION_REQUIRED]: 'Åtgärd krävs',
  [INTEGRATION_STATUS.INACTIVE]: 'Inaktiv',
};

export type MonitorEvent =
  | GenericEventPigello
  | GenericEventWebhook
  | GenericEventCron;

export type TaggedMonitorEvent = MonitorEvent & {
  monitorEventKind: MonitorEventKind;
};

export type IntegrationErrorContent = {
  title: string;
  description: string;
  stepsHeading?: string;
  steps?: string[];
  benign?: boolean;
};

export type IntegrationStatusItem = {
  agentId: string;
  applicationId: string;
  serviceId: string;
  companyName: string;
  variantName: string | null;
  logo: string | undefined;
  categoryKey: IntegrationGroup;
  categoryLabel: string;
  activationLabel: string | null;
  activationObjectId: string | null;
  status: IntegrationStatus;
  statusPending: boolean;
  lastSyncAt: string | null;
  hasFailures: boolean;
  errors: IntegrationErrorContent[];
  monitorUnavailable: boolean;
};

export type IntegrationStatusGroup = {
  key: string;
  applicationId: string;
  serviceId: string;
  companyName: string;
  variantName: string | null;
  logo: string | undefined;
  categoryKey: IntegrationGroup;
  categoryLabel: string;
  activationLabel: string | null;
  status: IntegrationStatus;
  statusPending: boolean;
  lastSyncAt: string | null;
  hasFailures: boolean;
  errors: IntegrationErrorContent[];
  monitorUnavailable: boolean;
  instances: IntegrationStatusItem[];
  attentionInstances: IntegrationStatusItem[];
};

export type IntegrationStatusCategory = {
  key: IntegrationGroup;
  label: string;
  integrations: IntegrationStatusGroup[];
};
